import React from 'react'
import BlacklistDoctorsComponnent from './../../../components/doctor/blackListDoctors/BlacklistDoctors';
function BlacklistDoctors() {
    return (
          <BlacklistDoctorsComponnent/>
    )
}
export default BlacklistDoctors